export const extractFirstSegmentFromUrl = (url: string) => {
  const regex = /^\/+\d+\/([^/#?]+).*$/;
  const match = url.replace(/[#?].*/, '').match(regex);
  return match ? match[1] : null;
};

export const removeFirstSlashInUrl = (url: string) =>
  url.startsWith('/') ? url.substring(1) : url;
